"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/**
 * 对应表体的一格
 */
var react_1 = tslib_1.__importDefault(require("react"));
var utils_1 = require("../utils");
var hooks_1 = require("./hooks");
function Cell(_a) {
    var cell = _a.cell, data = _a.data, value = _a.value;
    var tablePrefix = hooks_1.useTable().prefix;
    var bodyPrefix = utils_1.concat(tablePrefix, 'body');
    var index = cell.row.index;
    var cellData = data[index];
    var render = cell.column.meta.render;
    var getRowSpan = cell.column.meta.getRowSpan;
    var rowSpans = cell.column.meta.rowSpans;
    var rowSpan = getRowSpan === null || getRowSpan === void 0 ? void 0 : getRowSpan(value, cellData, index);
    if (rowSpan == null) {
        if (rowSpans[index] == null) {
            rowSpans[index] = 1;
        }
        rowSpan = rowSpans[index];
    }
    if (rowSpan === 0) {
        return null;
    }
    if (rowSpan > 1) {
        rowSpans.push.apply(rowSpans, new Array(rowSpan).fill(0));
    }
    return (react_1.default.createElement("td", tslib_1.__assign({}, cell.getCellProps({ className: utils_1.concat(bodyPrefix, 'td') }), { rowSpan: rowSpan }), render != null ? render(value, cellData, index) : value));
}
exports.default = Cell;
//# sourceMappingURL=Cell.js.map